// extracted by mini-css-extract-plugin
export var container = "_n2-0";
export var dotAnimation = "_n2-2";
export var dotsLoading = "_n2-1";